<template>
  <v-card>
    <v-toolbar dark color="darken-2" elevation="0" @short="true">
      <v-btn icon dark @click="fechar()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>
        <span>Incluir Interações</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="salvar()">Salvar</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-col>
        <v-row>
          <v-text-field
            v-model="quantidadeVisualizacoes"
            type="number"
            label="Visualizações"
            prepend-icon="remove_red_eye"
            color="darken-2"
            :messages="['Quantidade atual: '+hjVisualizacoes]"
          ></v-text-field>
        </v-row>
        <v-row>
          <v-text-field
            v-model="quantidadeCurtidas"
            type="number"
            label="Curtidas"
            prepend-icon="favorite"
            color="darken-2"
            :messages="['Quantidade atual: '+hjCurtidas]"
          ></v-text-field>
        </v-row>
      </v-col>
    </v-card-text>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import IteracaoService from "@/services/iteracaoService.js";
export default {
  props: ["editorial"],
  data() {
    return {
      quantidadeVisualizacoes: null,
      quantidadeCurtidas: null,
      overlay: false,
      hjVisualizacoes: 0,
      hjCurtidas: 0,
    };
  },
  methods: {
    async salvar() {
      this.overlay = true;
      await IteracaoService.registrarIteracaoAuto(
        this.editorial,
        2,
        this.quantidadeVisualizacoes
      );
      await IteracaoService.registrarIteracaoAuto(
        this.editorial,
        3,
        this.quantidadeCurtidas
      );
      this.overlay = false;

      this.quantidadeVisualizacoes = null;
      this.quantidadeCurtidas = null;
      this.caregarInteracoes();
      this.$emit("salvar", true);
    },
    fechar() {
      this.$emit("fechar", false);
    },
    async caregarInteracoes() {
      var rVis = await IteracaoService.listarIteracaoSimplificado(
        this.editorial,
        2
      );
      var rCur = await IteracaoService.listarIteracaoSimplificado(
        this.editorial,
        3
      );

      if (rVis.data.data.listarIteracaoSimplificado.length > 0) {
        this.hjVisualizacoes =
          rVis.data.data.listarIteracaoSimplificado[0].quantidade;
      } else {
        this.hjVisualizacoes = 0;
      }
      if (rCur.data.data.listarIteracaoSimplificado.length > 0) {
        this.hjCurtidas =
          rCur.data.data.listarIteracaoSimplificado[0].quantidade;
      } else {
        this.hjCurtidas = 0;
      }
    },
  },
  watch: {},
  created() {
    this.caregarInteracoes();
  },
};
</script>

<style>
</style>
